// extracted by mini-css-extract-plugin
export var contrastLow = "_25-1";
export var externalLink = "_25-2";
export var externalLinkIcon = "_25-3";
export var link = "_25-0";
export var linkLabel = "_25-4";